import { render, staticRenderFns } from "./FactorCreate.vue?vue&type=template&id=2d2e83e1"
import script from "./FactorCreate.vue?vue&type=script&lang=js"
export * from "./FactorCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports